export const PrefValues = Object.freeze({
	stampsOffers: 1,
	monthlyNewsletter: 4,
	partnerOffers: 2,
	autoDial: 8,
	sendMarketingSms: 16,
});

export const LogFields = Object.freeze({
	stampsOffers: 'product_offers',
	monthlyNewsletter: 'newsletter',
	partnerOffers: 'partner_offers',
	autoDial: 'autodial_consent',
	sendMarketingSms: 'sms_consent',
});
